import { render, staticRenderFns } from "./TabsSingle.vue?vue&type=template&id=16bfc790&"
import script from "./TabsSingle.vue?vue&type=script&lang=js&"
export * from "./TabsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports